/**
 * Classification helpers for submission/sample test types.
 *
 * Antibody submissions arrive through the DSA pathway and carry a test type
 * (sourced from GENE_FAMILY_CDE) that always starts with "DSA" but is not a
 * single fixed value (e.g. "DSA Antibody", "DSA Class I", "DSA Class II", ...).
 * Anything in this family is FHIR/antibody content that is view-only in the
 * dashboard (no edit, resubmit, or reprocess).
 *
 * Matching is done on the "DSA" prefix, case-insensitively and trimmed, so all
 * current and future DSA variations are treated consistently.
 */
export function isDsaTestType(testType: string | null | undefined): boolean {
    if (!testType) {
        return false;
    }
    return testType.trim().toUpperCase().startsWith('DSA');
}
